import { useAuth } from '@/components/auth/SupabaseAuthProvider';
import { useState } from 'react';
import { supabase } from '@/lib/supabase';

export function useStripePortal() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const redirectToPortal = async () => {
    if (!user) {
      setError(new Error('User not authenticated'));
      return;
    }

    try {
      setLoading(true);
      const { data: { session } } = await supabase.auth.getSession();
      
      const { data, error } = await supabase.functions.invoke('create-portal-session', {
        body: { userId: user.id },
        headers: { Authorization: `Bearer ${session?.access_token}` }
      });

      if (error) throw error;

      if (!data?.url) {
        throw new Error('No portal URL returned');
      }

      // Redirect to Stripe Portal
      window.location.href = data.url;
    } catch (err) {
      console.error('Error redirecting to portal:', err);
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  return {
    redirectToPortal,
    loading,
    error
  };
}
